module.exports = __webpack_public_path__ + "static/media/DK_4021.2865e688.jpg";